export enum ScheduleCalendarActionTypes {
  Confirm = 'confirm',
  Reschedule = 'reschedule',
  RequestChanges = 'requestChanges',
}

export enum ScheduleCalendarActionLocationTypes {
  Calendar = 'calendar',
  List = 'list',
}

export enum ScheduleStatusTypes {
  Confirmed = 'Confirmed',
  ToBeConfirmed = 'To Be Confirmed',
  ToBeConfirmedByDNV = 'DNV To Confirm',
  Completed = 'Completed',
  InProgress = 'In Progress',
}
